import { branch, compose, renderNothing } from 'recompose';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import WithTimezone from '../../hoc/WithTimezone';
import {
  getActiveDay,
  getNextAvailableTime,
  getIsWholeDayOff,
  getActiveTime,
} from '../selectors';
import WaitingListLink from '../../components/WaitingListLink';
import { getServiceName } from '../../services/selectors';
import { parseTimeSlug } from '../../utils/helpers';
import { getBarberByIdOrRoute } from '../../barbers/selectors';
import { getShopByRoute } from '../../shops/selectors';

export default compose(
  WithTimezone,
  withRouter,
  connect((state, ownProps) => {
    const activeDay = getActiveDay(state);
    const noNextAvailableTime = !getNextAvailableTime(state, activeDay, ownProps.timezone);
    const isWholeDayOff = getIsWholeDayOff(state, activeDay);
    return {
      shouldHideLink: noNextAvailableTime || isWholeDayOff,
      service: getServiceName(state, ownProps.params.serviceId),
      date: getActiveDay(state),
      time: parseTimeSlug(getActiveTime(state), ownProps.timezone),
      barber: getBarberByIdOrRoute(state, ownProps.params.barberRoute),
      shop: getShopByRoute(state, ownProps.params.shopRoute),
    };
  }),
  branch(props => props.shouldHideLink, renderNothing),
)(WaitingListLink);



// WEBPACK FOOTER //
// ./src/app/times/containers/WaitingListLink.js